// Kawaii minimalist front-view body diagram with tappable regions for cellulitis marking.
// Regions map to keys used by backend.

const REGIONS = [
  // [key, label, SVG element (rect or ellipse), center for label]
  { key: "head",             label: "Head",       shape: "ellipse", cx: 120, cy: 40, rx: 20, ry: 22 },
  { key: "neck",             label: "Neck",       shape: "rect", x: 110, y: 62, w: 20, h: 12 },
  { key: "chest",            label: "Chest",      shape: "rect", x: 90,  y: 76, w: 60, h: 45 },
  { key: "abdomen",          label: "Abdomen",    shape: "rect", x: 92,  y: 122, w: 56, h: 40 },
  { key: "left_upper_arm",   label: "L Upper arm", shape: "rect", x: 62,  y: 78, w: 22, h: 45 },
  { key: "left_forearm",     label: "L Forearm",   shape: "rect", x: 58,  y: 124, w: 22, h: 45 },
  { key: "left_hand",        label: "L Hand",      shape: "rect", x: 56,  y: 170, w: 22, h: 20 },
  { key: "right_upper_arm",  label: "R Upper arm", shape: "rect", x: 156, y: 78, w: 22, h: 45 },
  { key: "right_forearm",    label: "R Forearm",   shape: "rect", x: 160, y: 124, w: 22, h: 45 },
  { key: "right_hand",       label: "R Hand",      shape: "rect", x: 162, y: 170, w: 22, h: 20 },
  { key: "left_upper_leg",   label: "L Upper leg", shape: "rect", x: 92,  y: 164, w: 26, h: 60 },
  { key: "left_lower_leg",   label: "L Lower leg", shape: "rect", x: 94,  y: 225, w: 24, h: 60 },
  { key: "left_foot",        label: "L Foot",      shape: "rect", x: 92,  y: 286, w: 28, h: 18 },
  { key: "genital",          label: "Pelvic",     shape: "rect", x: 111, y: 164, w: 18, h: 22 },
  { key: "right_upper_leg",  label: "R Upper leg", shape: "rect", x: 122, y: 164, w: 26, h: 60 },
  { key: "right_lower_leg",  label: "R Lower leg", shape: "rect", x: 122, y: 225, w: 24, h: 60 },
  { key: "right_foot",       label: "R Foot",      shape: "rect", x: 120, y: 286, w: 28, h: 18 },
];

export default function BodyDiagram({ selected = [], onToggle, readOnly = false, size = 240 }) {
  const isSelected = (k) => selected.includes(k);

  return (
    <div className="flex justify-center" data-testid="body-diagram">
      <svg viewBox="0 0 240 320" width={size} height={(320/240) * size} className="select-none">
        <defs>
          <linearGradient id="bd-gradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFF9F9" />
            <stop offset="100%" stopColor="#FFE5E5" />
          </linearGradient>
          <linearGradient id="bd-active" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FF6B6B" />
            <stop offset="100%" stopColor="#E63946" />
          </linearGradient>
        </defs>

        {REGIONS.map((r) => {
          const active = isSelected(r.key);
          const fill = active ? "url(#bd-active)" : "url(#bd-gradient)";
          const stroke = active ? "#E63946" : "#FFB7B2";
          const strokeWidth = active ? 1.5 : 1;
          const commonProps = {
            fill, stroke, strokeWidth,
            className: readOnly ? "" : "cursor-pointer hover:opacity-90 transition-opacity",
            onClick: readOnly ? undefined : () => onToggle && onToggle(r.key),
            "data-testid": `body-region-${r.key}`,
            "data-active": active ? "true" : "false",
          };
          return r.shape === "ellipse" ? (
            <ellipse key={r.key} cx={r.cx} cy={r.cy} rx={r.rx} ry={r.ry} {...commonProps} />
          ) : (
            <rect key={r.key} x={r.x} y={r.y} width={r.w} height={r.h} rx={6} {...commonProps} />
          );
        })}

        {/* soft outline */}
        <ellipse cx="120" cy="40" rx="20" ry="22" fill="none" stroke="#FFB7B2" strokeWidth="1" pointerEvents="none" />
      </svg>
    </div>
  );
}

export const BODY_REGIONS = REGIONS;
export const REGION_LABEL = Object.fromEntries(REGIONS.map((r) => [r.key, r.label]));
